export default "__VITE_ASSET__b7ecbcb6__"